import { useMutation, useQuery } from '@/hooks'
import { useQueryClient } from '@tanstack/react-query'

export type Expense = {
  id: string
  expense_date: string
  category: string
  amount: number
  note?: string | null
  location?: string | null
  created_at?: string
  updated_at?: string
}

export type ExpenseListResponse = {
  data: Expense[]
  meta: { total: number; amount_total: number; currentPage: number; totalPages: number }
}

export const useExpenseList = (params?: {
  start_date?: string
  end_date?: string
  page?: number
  limit?: number
  location?: string
}) => {
  return useQuery<ExpenseListResponse>({
    queryKey: ['expenses', params],
    url: '/expenses',
    axiosConfig: { params },
  })
}

export const useCreateExpense = () => {
  const qc = useQueryClient()
  return useMutation<
    any,
    Error,
    { expense_date: string; category?: string; amount: number; note?: string; location?: string }
  >(
    ['expenses_create'],
    { url: '/expenses', method: 'POST' },
    {
      onSuccess: () => qc.invalidateQueries({ queryKey: ['expenses'] }),
    },
  )
}

export const useDeleteExpense = () => {
  const qc = useQueryClient()
  return useMutation<any, Error, { id: string }>(
    ['expenses_delete'],
    { url: `/expenses/:id`, method: 'DELETE' },
    {
      onSuccess: () => qc.invalidateQueries({ queryKey: ['expenses'] }),
    },
  )
}
